export const themes = [
    {
        id: 1,
        name: "Darwinian2023",
    },
    //{
    //    id: 2,
    //    name: 'DaisyRGB2024'
    //}
]